import React from "react";
import styled from "@emotion/styled";
import LogoutIcon from "@icons/myicons/sidebar/logout.svg?react";
import { Box, IconButton, Typography } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import BurgerIcon from "@icons/myicons/sidebar/burger.svg?react";
import CloseIcon from "@icons/myicons/sidebar/close.svg?react";
import { SettingsMenu } from "@features/settings/components/SettingsSidebar/SettingsMenu";
import { SettingsMenuItem } from "@features/settings/components/SettingsSidebar/SettingsMenuItem.tsx";
import { BankConnections } from "@features/settings/components/SettingsSidebar/BankConnections.tsx";

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  width: "42px",
  height: "42px",
  padding: theme.spacing(1),
}));

const MobileHeaderContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: theme.palette.background.subtle,

  "&::-webkit-scrollbar": {
    display: "none",
  },
}));

const Container = styled(motion.div)<{ showDropdown: boolean }>`
  display: flex;
  flex-direction: column;
  z-index: 4000;
  padding: ${({ theme }) => theme.spacing(1.5, 2)};
  background-color: ${({ theme }) => theme.palette.background.subtle};
  align-items: stretch;
  justify-content: space-between;
  overflow: ${({ showDropdown }) => (showDropdown ? "auto" : "hidden")};
  position: fixed;
  top: 0;
  width: 100%;
  padding-bottom: ${({ theme }) => theme.spacing(6)};
  "&::-webkit-scrollbar": {
    display: none;
  }
`;

export const SettingsMobileHeader = () => {
  const { t } = useTranslation();
  const [showDropdown, setShowDropdown] = React.useState(false);
  const navigate = useNavigate();

  return (
    <Container
      showDropdown={showDropdown}
      animate={{ height: !showDropdown ? "54px" : window.innerHeight }}
    >
      <Box display="flex" flexDirection="column" alignItems="stretch">
        <MobileHeaderContainer className="header-container">
          <Box display="flex" alignItems="center" gap={2}>
            <IconButton
              onClick={() => navigate(-1)}
              size="small"
              sx={{
                "& svg": {
                  width: "20px",
                  height: "20px",
                },
              }}
            >
              <KeyboardArrowLeftIcon />
            </IconButton>
            <Typography variant="body2">
              {t("settings.sidebar.title")}
            </Typography>
          </Box>
          <Box display="flex">
            <StyledIconButton onClick={() => setShowDropdown(!showDropdown)}>
              {showDropdown ? <CloseIcon /> : <BurgerIcon />}
            </StyledIconButton>
          </Box>
        </MobileHeaderContainer>
        <SettingsMenu />
        <BankConnections />
      </Box>
      <Box mt={6}>
        <SettingsMenuItem
          active={false}
          to="/logout"
          title={t("appSidebar.menu.logout")}
          icon={
            <Box display="flex" alignItems="center" ml={-1}>
              <LogoutIcon />
            </Box>
          }
        />
      </Box>
    </Container>
  );
};
